<i18n>
{
  "en": {
      "subscription_confirmed": "Subscription confirmed."
  },
  "zhHant": {
      "subscription_confirmed": "訂閱已確認"
  },
  "ja": {
      "subscription_confirmed": "ご契約が完了しました"
  },
  "ko": {
      "subscription_confirmed": "구독이 확인되었습니다"
  }
}
</i18n>

<template>
  <v-container column justify-center items-center bg>
    <Spinner v-if="!ableToClick" />
    <v-layout v-else row wrap align-center>
      <v-alert value="true" type="success" outline style="width: 100%">{{ $t('subscription_confirmed') }}</v-alert>
      <v-btn color="info" block :disabled="!ableToClick" @click="$router.push({ name: 'home' })">
        <span>OK</span>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import Spinner from '@/components/ui/Spinner.vue';
import { trackAbConvert } from '@/misc/ab';

export default {
  name: 'stripe',
  components: {
    Spinner,
  },
  data() {
    return {
      checkout_session_id: this.$route.query.session_id, // not used for now
      ableToClick: false,
      second: 5,
    };
  },
  created() {
    // Reaching this route IS the confirmed subscription — the last step of
    // every landing-page A/B funnel.
    trackAbConvert('purchase', firebase.auth().currentUser);

    const timer = setInterval(() => {
      this.second -= 1;
      if (this.second === 0) {
        this.ableToClick = true;
        clearInterval(timer);
      }
    }, 1000);
  },
  computed: {},
  methods: {},
};
</script>
